import styled from 'styled-components';
import theme from './theme';
const { spacing } = theme;

const Footer = styled.footer`
  padding: ${spacing.base};
`;

export default Footer;
